module.exports = {"profile":{"educations":{"headline":"Ausbildung","emptyText":"Hier kannst du deine berufliche Ausbildung oder Lehrgänge eintragen."}}}